/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { FallbackProps } from 'react-error-boundary';
import React from 'react';
import styles from './Fallback.module.css';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@vaisala/rockhopper-components';

// this is a loud red unhappy face - please implement your own Fallback
// the Fallback also takes a resetErrorBoundary callback that can be used on e.g. a reset button
// this is currently use with an an ErrorBoundary wrapping a whole page but
// generally this should be used at a more fine-grained level, wrapping components that are complex
export const Fallback: React.FC<FallbackProps> = ({ error }: Partial<FallbackProps>) => {
  const { t } = useTranslation();

  return (
    <div className={styles.fallbackWrapper}>
      <h4>App error. Please reload the app.</h4>
      <BodyText>Error message: {error?.message || t('app.error')}</BodyText>
    </div>
  );
};
